var React = require('react');

function ContactEmail (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"38.5","cy":"38.5","r":"37","stroke":"#FF913A","strokeWidth":"3","key":0}),React.createElement("path",{"fill":"#FF913A","d":"M53.953 23.047H23.047a4.703 4.703 0 0 0-4.703 4.703v21.5a4.703 4.703 0 0 0 4.703 4.703h30.906a4.703 4.703 0 0 0 4.703-4.703v-21.5a4.703 4.703 0 0 0-4.703-4.703Zm-9.406 14.882 11.294-10.85c.08.214.124.441.128.671v21.608l-11.422-11.43ZM21.03 49.304V27.75c.004-.23.047-.457.128-.672L32.124 37.6 21.03 49.304Zm2.614-23.57h29.71L38.5 39.998 23.645 25.734Zm-.598 25.532h-.148L34.066 39.46l3.507 3.36a1.344 1.344 0 0 0 1.86 0l3.165-3.038 11.463 11.483H23.047Z","key":1})]);
}

ContactEmail.defaultProps = {"width":"77","height":"77","fill":"none","viewBox":"0 0 77 77"};

module.exports = ContactEmail;

ContactEmail.default = ContactEmail;
